import { render, staticRenderFns } from "./BuyAndTry.vue?vue&type=template&id=dc2c9c82"
import script from "./BuyAndTry.vue?vue&type=script&lang=js"
export * from "./BuyAndTry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports